<template>
  <div id="index" ref="appRef">
    <div class="loginBox">
      <div class="login">
        <h1 class="tit">SG-彭州智能浇灌系统登录</h1>
        <div class="txtBox">
          <div class="container">
            <div class="item">
              <input class="username" v-model="params.username" type="text" placeholder="请输入账号">
            </div>
            <div class="item">
              <input class="username" v-model="params.password" type="password" placeholder="请输入密码">
            </div>
            <!-- <div class="item">
              <input class="username" v-model="params.captcha" type="text" placeholder="请输入验证码">
            </div> -->
            <div class="item">
              <button class="btn" @click="handleClick">登录</button>
            </div>
            <p class="item">
              <input type="checkbox" checked />我已阅读并同意并遵守 <span class="col">用户协议</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import drawMixin from "../utils/drawMixin";
import { apiLogin } from '../api/api.js'
export default {
  mixins: [drawMixin],
  data () {
    return {
      params: {
        username: "",
        password: "",
        // captcha:""
      }
    }
  },
  components: {
  },
  mounted () {
  },
  methods: {
    handleClick () {
      this.$router.push('/main')
      apiLogin(this.params).then((result) => {
        if (result.code == 200) {
          localStorage.setItem('authToken', result.data)
          setTimeout(() => {
            this.$router.push('/main')
          }, 100)
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/index.scss';

.loginBox {
  width: 100%;
  height: 100%;
  background: url("../assets/loginBg.png");
  background-position: cover;

  .login {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    .tit {
      font-size: 59px;
      color: #fff;
    }

    .txtBox {
      margin: 0 auto;
      height: 454px;
      background: url('../assets/loginbox.png');
      background-size: contain;
      width: 589px;
      margin-top: 50px;
      padding: 30px;
      text-align: center;
      user-select: none;
      outline: none;

      .container {
        margin-top: 50px;

        .item {
          margin-bottom: 26px;

          .username {
            width: 96%;
            height: 50px;
            background: #F5F5F5;
            border: none;
            padding-left: 10px;
            font-size: 20px;
          }

          .btn {
            margin-top: 30px;
            background-color: #24CFF4;
            color: #fff;
            width: 359px;
            height: 55px;
            font-size: 26px;
          }

          .col {
            color: #24CFF4;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
